
import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Popper, Select, TextField } from '@material-ui/core';
import { SelectItem } from '../../common.types';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { getMode } from '../../utils/ui.utils';

type Props = {
label: string,
data: SelectItem[],
helperText?: string,
handleChange: (event: any) => void,
disabled?: boolean,
defaultValue?: SelectItem,
multiple?: boolean
};

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
}));

const getItems = (data: SelectItem[]) => {
    return data.map(item => {
        const menuItem = (
            <MenuItem value={item.value}>{item.name}</MenuItem>
        )
        return menuItem;
    })
}

const styles = () =>{
    return {
        popper: {
            width: "fit-content"
        }
    }
}

const PopperMy = function (props: any) {
    return <Popper {...props} style={styles().popper} placement="bottom-start" />;
 };

export const SportResultsDropdown: FC<Props> = props => {
    const classes = useStyles();
    const [selection, setSelection] = useState<SelectItem>(null)
    const handleChange = (option: SelectItem) => {
        setSelection(option ? option.value : null);
        props.handleChange(option);
      };
    const mode = useSelector<RootState>(x => x.mode.model ?? getMode()) as 'light' | 'dark'
    const controlId = `sportresults-dropdown__${props.label}`;
    return (
        <FormControl disabled={props.disabled} className={classes.formControl} style={{color: 'white'}}>
                    <Autocomplete
                    noOptionsText={"Mangel på værdier"}
                    multiple={props.multiple}
                    defaultValue={props.defaultValue}
                    disabled={props.disabled}
                    PopperComponent = {PopperMy}
                    fullWidth={true}
                    id={controlId}
                    renderOption={(option,state) => <label style={{color: mode == 'light' ? 'initial' : 'white'}}>{option.name}</label>}
                    getOptionSelected={(option: SelectItem,value: SelectItem) => option.value == value.value}
                    options={props.data}
                    color={'white'}
                    getOptionLabel={(option: SelectItem) => option.name}
                    onChange={(event: any, option: any) => handleChange(option)}
                    renderInput={(params) => <TextField {...params} label={props.label} />}
                    />
                { props.helperText && <FormHelperText>{ props.helperText }</FormHelperText> }
        </FormControl>  
    )
}